import * as React from "react";

function Notification(props) {
  return (
    <svg width={24} height={25} fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.324 20.606c.518.577 1.183.894 1.873.894h.001c.693 0 1.361-.317 1.88-.895a.75.75 0 011.115 1.004c-.808.897-1.87 1.391-2.995 1.391h-.002c-1.12-.001-2.182-.495-2.987-1.392a.749.749 0 111.115-1.002zM12.247 1.5c4.445 0 7.431 3.462 7.431 6.695 0 1.663.423 2.368.872 3.116.444.738.947 1.576.947 3.16-.349 4.047-4.574 4.377-9.25 4.377S3.345 18.518 3 14.535c-.003-1.648.5-2.486.944-3.224l.157-.264c.386-.663.715-1.385.715-2.852 0-3.233 2.986-6.695 7.431-6.695zm0 1.5c-3.495 0-5.93 2.738-5.93 5.195 0 2.079-.578 3.04-1.088 3.888-.409.681-.732 1.219-.732 2.388.167 1.886 1.412 2.877 7.75 2.877 6.303 0 7.587-1.035 7.753-2.942-.003-1.104-.326-1.642-.735-2.323-.51-.848-1.087-1.809-1.087-3.888 0-2.457-2.436-5.195-5.93-5.195z"
        fill="currentColor"
        stroke="none"
      />
    </svg>
  );
}

const NotificationIcon = React.memo(Notification);
export default NotificationIcon;
